import { client } from 'api/baseApi.ts';
import LoadingScreen from 'core/navigation/loading-screen/LoadingScreen';
import RouterConfig from 'core/navigation/RouterConfig';
import { captureDatadogErrors } from 'core/utils/datadogUtil';
import { LoggerUtil } from 'core/utils/loggerUtil.ts';
import { store } from 'platform/web/store';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const clientData = client;
const root = ReactDOM.createRoot(document.getElementById('root'));
export const persistor = persistStore(store);
root.render(
	<Provider store={store}>
		<Suspense fallback={<LoadingScreen />}>
			<PersistGate loading={<LoadingScreen />} persistor={persistor}>
				<RouterConfig />
			</PersistGate>
		</Suspense>
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
	// Note: Commented for later Usages to unregister service workers
	// navigator.serviceWorker.getRegistrations().then((registrations) => {
	// 	// eslint-disable-next-line no-restricted-syntax
	// 	for (const registration of registrations) {
	// 		registration.unregister();
	// 	}
	// });
	navigator.serviceWorker
		.register('/sw-v1.0.2.js')
		.then((registration) => {
			// eslint-disable-next-line no-console
			LoggerUtil.logInfo('ServiceWorker registration successful', registration);
			return registration.update();
		})
		.catch((err) => {
			// eslint-disable-next-line no-console
			LoggerUtil.logInfo('ServiceWorker registration failed: ', err);
		});
	navigator.serviceWorker.onmessage = (event) => {
		const { data } = event;
		if (data?.error) {
			LoggerUtil.logInfo('ServiceWorker error message: ', data?.message);
			captureDatadogErrors(data?.message, {});
		}
	};
}
